import service from './service';

export default {
  // 查看我的企业资料
  getCompany() {
    return service.get('/api/v1/company');
  },
  // 获取企业大分类
  getSubareaList() {
    return service.get('/api/v1/company/subarea/list');
  },

  // 获取企业小分类（行业性质下的行业分类）
  getCategoryList(subareaId) {
    return service.get(`/api/v1/company/${subareaId}/category`);
  },
  // 获取区域列表
  getRegionList() {
    return service.get('/api/v1/address/city')
  },
  // 获取规模列表
  getScaleList() {
    return service.get('/api/v1/company/scale/list')
  },
  // 获取福利列表
  getWelfareList() {
    return service.get('/api/v1/company/welfare/list')
  },
  // 提交公司信息
  patchCompanyInfo(info) {
    return service.patch('/api/v1/company', info);
  },
  // 获取职位模板
  getTemplate(id) {
    return service.get(`/api/v1/info/${id}/template/list`)
  },
  // 企业形象图片汇报
  reportPic(data) {
    return service.post('/api/v1/company/upload/style', data);
  }
}



// WEBPACK FOOTER //
// ./src/api/enterpriseInfo.js